import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./model.css";
import "./addticket.css";
import axiosinstances from "../../Helper/useAxios";
import { useSelector } from "react-redux";
import { dangerColor, primaryColor } from "../../utils/comman/Common";
import { useNavigate } from "react-router-dom";
import moment from "moment";

export default function AddToken(props) {
  const navigate = useNavigate();
  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const [axiosInstance] = axiosinstances(userIp);
  const {
    tokenRequest,
    tokenChangeHandle,
    handleFileChange,

    createNewToken,
    attachmentId,
    show,
    handleShow,
    handleClose,
    selectedTraxn,
    setShowTicketDropdown,
    showTicketDropdown,
    selectedTicket,
    setselectedTicket,
    isAllTicketResolved,
    setIsAllTicketResolved,
    ticketLists,
    setTicketLists,
    handleUpdateUtrShow,
  } = props;
  // const [ticketLists, setTicketLists] = useState(null);
  const [loading, setLoading] = useState(false);
  const e = JSON.parse(sessionStorage.getItem("token"));
  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );
  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": sessionId,
    "request-id": reqId,
  };

  function isSuccessStatus(status) {
    if (typeof status === "string" && status.startsWith("SUCCESS_")) {
      return false;
    } else if (status == "UNPROCESSED") {
      return false;
    } else {
      return true;
    }
  }
  // const type
  const getTicketStatus = async () => {
    setLoading(true);
    setTicketLists(null);
    const url = `/api/v1/upi/ticket/check/${tokenRequest?.type}/${selectedTraxn?.id}`;
    // setDataLoading(true);
    const response = await axiosInstance
      .get(url, { headers })
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.tickets !== undefined) {
            setTicketLists(res?.data?.tickets);
          }

          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });

    if (response) {
      const result = response.data.tickets;

      if (result) {
      }

      return response.data;
    }
    setLoading(false);
    return false;
  };
  useEffect(() => {
    if (selectedTraxn?.id !== undefined) {
      getTicketStatus();
    }
  }, [selectedTraxn?.id]);
  useEffect(() => {
    if (Array.isArray(ticketLists) && ticketLists.length == 1) {
      const val = ticketLists[0];

      setselectedTicket(val?.id);
    }
  }, [ticketLists]);
  //Array.isArray(ticketLists) && ticketLists.length > 0
  //ticketLists
  useEffect(() => {
    if (
      ticketLists !== undefined &&
      ticketLists !== null &&
      Array.isArray(ticketLists) &&
      ticketLists.length > 0
    ) {
      for (let i = 0; i < ticketLists.length; i++) {
        if (!ticketLists[i]?.resolved) {
          setIsAllTicketResolved(false);
          break;
        }
      }
    }
  }, [ticketLists]);
  const selectTicketHandler = (e) => {
    setselectedTicket(e.target.value);
  };
  const openDetailsPage = (data) => {
    navigate("/ticket-details", { state: { data: { id: selectedTicket } } });
  };
  const showOptions = (val) => {
    const createdOn = moment(val?.createdOn).format("YYYY-MM-DD");
    const singleTicketOption = `${createdOn} ${val?.id} ${
      val.resolved ? "Closed" : "Open"
    }`;
    return singleTicketOption;
  };
  const showUpdateUtr = () => {
    return (
      <Button
        variant="info"
        onClick={() => handleUpdateUtrShow(selectedTraxn)}
        style={{ color: "#fff" }}
      >
        Update UTR
      </Button>
    );
  };
  return (
    <>
      <Modal show={show} onHide={handleClose} dialogClassName="custom-modal">
        <Modal.Header closeButton>
          <Modal.Title>Ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Your modal body content here */}

          {loading ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div class="modal-body">
              <div class="container">
                {/* <!-- project  first row --> */}
                {Array.isArray(ticketLists) && ticketLists.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "10px",
                    }}
                  >
                    {isSuccessStatus(selectedTraxn?.status) && showUpdateUtr()}
                  </div>
                )}
                {showTicketDropdown ? (
                  <>
                    <div class="row">
                      <div class="col-12">
                        <div class="project-model">
                          <label for="">
                            Type<span class="text-danger">*</span>
                          </label>
                          <select
                            value={tokenRequest?.type}
                            onChange={tokenChangeHandle}
                            name="type"
                            class="form-select bg-light"
                          >
                            <option value={null}>
                              <i
                                class="fa-solid fa-square-check"
                                style={{ color: "#7ea6ec" }}
                              ></i>{" "}
                              Select type
                            </option>
                            <option value="PAY_IN">PAY_IN</option>
                            <option value="PAY_OUT">PAY_OUT</option>
                          </select>
                          {/* <a href="#">Learn More</a> */}
                        </div>
                      </div>
                    </div>
                    <hr />
                    {/* <!-- status Secoond row --> */}
                    <div class="row">
                      <div class="col-12  mb-3">
                        <label for="">
                          User UTR <span class="text-danger">*</span>
                        </label>
                        <input
                          style={{ border: "1px solid green" }}
                          value={tokenRequest?.userUtr}
                          onChange={tokenChangeHandle}
                          type="text"
                          max={11}
                          pattern="[0-9]*"
                          maxLength={12}
                          name="userUtr"
                          id=""
                          class="form-control border inputbg border-2"
                        />
                      </div>

                      <div class="col-12  mb-3">
                        <label for="">Comments </label>
                        <input
                          value={tokenRequest?.comments}
                          type="text"
                          onChange={tokenChangeHandle}
                          name="comments"
                          id=""
                          class="form-control border inputbg border-2"
                        />
                      </div>
                      <div class="col-12  mb-3">
                        <label for="">
                          User Txn Date <span class="text-danger">*</span>
                        </label>
                        <input
                          value={tokenRequest?.userTxnDate}
                          type="date"
                          onChange={tokenChangeHandle}
                          name="userTxnDate"
                          id=""
                          class="form-control border inputbg border-2"
                        />
                      </div>
                      {/* <!-- Description --> */}
                      <div class="col-12 mb-3">
                        <label for="">
                          Description <span class="text-danger">*</span>
                        </label>
                        <textarea
                          value={tokenRequest?.description}
                          onChange={tokenChangeHandle}
                          name="description"
                          id=""
                          cols="30"
                          rows="5"
                          class="form-control"
                        ></textarea>
                      </div>
                      {/* <!-- Attachment --> */}
                      <div class="col-12 mb-3">
                        <div>
                          <label htmlFor="attachment">Attachment</label>
                          <div className="border border-dotted text-center p-5">
                            <label
                              htmlFor="fileInput"
                              className="text-decoration-none"
                            >
                              <i className="fa fa-cloud-arrow-up"></i>Drop files
                              to attach or browse
                            </label>
                            <input
                              type="file"
                              id="fileInput"
                              accept="image/png, image/jpeg"
                              style={{ display: "none" }}
                              onChange={handleFileChange}
                            />
                            {attachmentId?.name !== undefined &&
                              attachmentId?.name !== null && (
                                <p>Selected file: {attachmentId?.name}</p>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div class="row">
                    {Array.isArray(ticketLists) && ticketLists.length > 0 && (
                      <div class="col-12">
                        <div class="project-model">
                          <label for="">
                            Previous Ticket List{" "}
                            <span class="text-danger">*</span>
                          </label>
                          <select
                            value={selectedTicket}
                            onChange={selectTicketHandler}
                            name="type"
                            class="form-select bg-light"
                          >
                            {Array.isArray(ticketLists) &&
                              ticketLists.length > 1 && (
                                <option value={null}>
                                  <i
                                    class="fa-solid fa-square-check"
                                    style={{ color: "#7ea6ec" }}
                                  ></i>{" "}
                                  Select Ticket
                                </option>
                              )}
                            {Array.isArray(ticketLists) &&
                              ticketLists.length > 0 &&
                              ticketLists.map((val) => (
                                <option value={val.id}>
                                  {showOptions(val)}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    )}

                    {isAllTicketResolved && (
                      <>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <Button
                              variant="primary"
                              onClick={() => setShowTicketDropdown(true)}
                            >
                              Create Ticket
                            </Button>

                            {isSuccessStatus(selectedTraxn?.status) &&
                              showUpdateUtr()}
                          </div>
                          <p style={{ color: "green", marginTop: "10px" }}>
                            Your all tickets are close so you can create new
                            ticket
                          </p>
                        </div>
                      </>
                      // <>
                      //   <div
                      //     class={`col-12 ${
                      //       Array.isArray(ticketLists) &&
                      //       ticketLists.length > 0 &&
                      //       "mt-5"
                      //     } mb-2 d-flex justify-content-center`}
                      //   >
                      //     <Button
                      //       variant="primary"
                      //       onClick={() => setShowTicketDropdown(true)}
                      //     >
                      //       Create Ticket
                      //     </Button>
                      //   </div>
                      //   <small
                      //     style={{ color: "green" }}
                      //     className="d-flex justify-content-center"
                      //   >
                      //     Your all tickets are close so you can create new
                      //     ticket
                      //   </small>
                      // </>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {
            // openDetailsPage
            showTicketDropdown ? (
              <Button variant="primary" onClick={createNewToken}>
                Create
              </Button>
            ) : !showTicketDropdown &&
              Array.isArray(ticketLists) &&
              ticketLists.length > 0 ? (
              <Button
                disabled={selectedTicket == undefined || selectedTicket == null}
                variant="primary"
                onClick={openDetailsPage}
              >
                Show
              </Button>
            ) : null
          }
        </Modal.Footer>
      </Modal>
    </>
  );
}
